// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"673f4c9a","81":"1f49e491","195":"fb91c542","254":"eb268c18","309":"25b21c82","453":"f3693c92","606":"4b4f4e5f","624":"19d74027","656":"e235b4d5","705":"eb31bcc8","858":"3506e839","880":"5fc0ab23","914":"5a27a119"}[chunkId] + ".chunk.js";
};